export const transformCategories = (data) => {
  // Filter the data for items with status true
  const filteredData = data.filter((item) => item.status);

  // Sort by display_order to ensure correct order
  const sortedData = filteredData.sort(
    (a, b) => a.display_order - b.display_order
  );

  // Function to calculate total items count
  const calculateTotalItems = () => {
    return sortedData?.reduce((acc, item) => acc + (item.items_count || 1), 0);
  };

  // Calculate total items count
  const totalItemsCount = calculateTotalItems();

  // Add "All Menu" as the first category
  const categories = [
    {
      id: "All Menu",
      name: "All Menu",
      items: `${totalItemsCount} items`,
      ItemsCount: totalItemsCount,
    },
  ];

  // Create the categories array
  sortedData.forEach((item) => {
    categories.push({
      id: item.id,
      name: item.name_en,
      items: `${item.items_count} items`,
      ItemsCount: item.items_count,
      selection_rules: item.selection_rules || item.choose_rule, // Support both naming conventions
    });
  });

  return categories;
};

export const generateUniqueItemIdentifier = () => {};

export const generateVariantId = (selectedVariants, instructions) => {
  // Create a normalized representation of the selections
  const normalizedSelections = selectedVariants
    .map((variant) => {
      // Create a selection key that includes both option IDs and their quantities
      const optionsKey = variant.options
        .map((opt) => `${opt.option_id}_${opt.option_quantity}`)
        .sort()
        .join("|");

      return {
        variant_id: variant.variant_id,
        variant_type: variant.variant_type,
        options_key: optionsKey,
      };
    })
    .sort((a, b) => a.variant_id - b.variant_id);

  // Create a string representation of the selection
  const selectionString = JSON.stringify({
    selections: normalizedSelections,
    instructions: instructions || "",
  });

  // Create a hash of the string
  let hash = 0;
  for (let i = 0; i < selectionString.length; i++) {
    const char = selectionString.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32-bit integer
  }

  return `${selectedVariants[0]?.variant_id || 0}_${hash}`;
};

export const transformAddToCartPayload = (
  customerId,
  item,
  restaurantDetails,
  instructions,
  variantItem = null
) => {
  // Base payload structure
  const basePayload = {
    customer_id: customerId,
    item_code: crypto.randomUUID(),
    item_id: item.id,
    restaurant_id: restaurantDetails.restaurantId,
    branch_id: restaurantDetails.branchId,
    promo_code_type: "",
    promo_code: "",
    item_discount_price: item.discounted_price || "",
    topping_variant_id: null,
    side_variant_id: null,
    size_variant_id: null,
    custom_variant_id: "",
    size_variant: [],
    topping_variant: [],
    custom_variant: [],
    side_variant: [],
    special_instructions: instructions || "",
  };

  // If it's not a variant item, return the base payload with the item's quantity
  if (!item.has_variants) {
    return {
      ...basePayload,
      quantity: item.quantity || 1
    };
  }

  // For variant items, we need the specific variantItem that was passed
  if (!variantItem) {
    console.error("Variant item is required for items with variants");
    return basePayload;
  }

  // Create a payload with the variant item's quantity
  const payload = {
    ...basePayload,
    quantity: variantItem.quantity || 1,
    special_instructions: variantItem.instructions || instructions || "",
  };

  // Process the selected variants for this specific variant item
  variantItem.selectedVariant.forEach((variant, index) => {
    const suffix = index === 0 ? "" : (index + 1).toString();

    // Set variant ID
    payload[`custom_variant_id${suffix}`] = variant.variant_id.toString();

    // Set variant options
    payload[`custom_variant${suffix}`] = variant.options
      .filter((opt) => opt.option_quantity > 0)
      .map((opt) => ({
        option_id: opt.option_id,
        option_quantity: opt.option_quantity,
      }));
  });

  return payload;
};

export const updateSubtotal = (items) => {
  const parsePrice = (priceStr) => {
    if (typeof priceStr !== "string") return 0;
    // Handle "KWD X.XXX" format by removing the prefix
    const numberPart = priceStr.replace("KWD ", "");
    return parseFloat(numberPart) || 0;
  };

  return items?.reduce((total, item) => {
    const itemPrice = parsePrice(item.price);
    let itemTotal = itemPrice * (item.quantity || 0);

    if (item.has_variants && item.items && Array.isArray(item.items)) {
      item.items.forEach(variantItem => {
        const variantQuantity = variantItem.quantity || 0;
        itemTotal = itemPrice * variantQuantity;
      });
    }

    return total + itemTotal;
  }, 0);
};
